'use client'

import {Suspense} from 'react'
import dynamic from 'next/dynamic'
import {useParams} from 'next/navigation'
import {useEffect, useState} from 'react'
import {useLivestreamPlayer} from '@/context/LivestreamPlayerContext'
const IframePlayer = dynamic(() => import('@/components/IframePlayer'))
    

export default function CheckPlayer() {
  const params = useParams()
  const broadNoParam = params.broadNo as string
  const {broadNo} = useLivestreamPlayer()
  const [isIframe, setIsIframe] = useState<boolean>(false)

  useEffect(() => {  
    if (broadNoParam == 'direct'|| broadNoParam == 'dashboard') {   
      setIsIframe(true)
    } else {
      setIsIframe(false)
    }
  }, [broadNoParam])

  return (
    <>
      <Suspense fallback={<p>Loading ...</p>}>
        <IframePlayer broadNo={broadNo} type={broadNoParam} isIframe={isIframe}/>
      </Suspense>
    </>
  )
}
